import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Space, Avatar, Dropdown, Tooltip, message } from 'antd';
import {
  DashboardOutlined, UserOutlined, ShoppingOutlined,
  SendOutlined, LinkOutlined, SettingOutlined, LogoutOutlined,
  RiseOutlined, ImportOutlined, DesktopOutlined, FieldTimeOutlined,
  FileTextOutlined, ClockCircleOutlined, UploadOutlined, CloudOutlined,
  BarChartOutlined, FormOutlined, BellOutlined,
  AppstoreOutlined, TeamOutlined, ShopOutlined, VideoCameraOutlined, SafetyCertificateOutlined,
  DatabaseOutlined, InboxOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
} from '@ant-design/icons';
import { useAuth } from '../auth/AuthContext';
import { getApiErrorMessage } from '../api/client';

const { Sider, Content, Header } = Layout;

// ───────── 菜单配置（保持原有权限逻辑不变） ─────────

const adminMenu = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: '数据看板', group: '数据' },
  { key: '/workload-dashboard', icon: <BarChartOutlined />, label: '工作量看板', group: '数据' },
  { key: '/today-workbench', icon: <BellOutlined />, label: '今日工作台', group: '业务' },
  { key: '/anchors', icon: <UserOutlined />, label: '达人管理', group: '业务' },
  { key: '/my-anchors', icon: <UserOutlined />, label: '我的达人', group: '业务' },
  { key: '/creator-leads', icon: <TeamOutlined />, label: '达人建联', group: '业务' },
  { key: '/merchant-leads', icon: <ShopOutlined />, label: '招商公海', group: '业务资源' },
  { key: '/public-pool', icon: <TeamOutlined />, label: '达人公海', group: '业务资源' },
  { key: '/operation-logs', icon: <FileTextOutlined />, label: '操作日志', group: '业务资源' },
  { key: '/admin/legacy-sample-binding', icon: <DatabaseOutlined />, label: '历史寄样待处理', group: '业务资源' },
  { key: '/products', icon: <ShoppingOutlined />, label: '商品列表', group: '业务' },
  { key: '/product-import', icon: <UploadOutlined />, label: '商品导入', group: '业务' },
  { key: '/brand-config', icon: <CloudOutlined />, label: '品牌配置', group: '业务' },
  { key: '/brand-workbench', icon: <AppstoreOutlined />, label: '品牌工作台', group: '品牌工作台' },
  { key: '/my-samples', icon: <InboxOutlined />, label: '我的寄样', group: '品牌工作台' },
  { key: '/admin/samples', icon: <DatabaseOutlined />, label: '管理员寄样总表', group: '品牌工作台' },
  { key: '/admin/batches', icon: <CloudOutlined />, label: '批次中心', group: '品牌工作台' },
  { key: '/admin/sync-config-onboarding', icon: <CloudOutlined />, label: '新品牌接入', group: '品牌同步中心' },
  { key: '/brand-sync-config', icon: <CloudOutlined />, label: '已接入配置', group: '品牌同步中心' },
  { key: '/brand-sync-status', icon: <FileTextOutlined />, label: '品牌同步状态', group: '品牌同步中心' },
  { key: '/admin/partner-channels', icon: <ShopOutlined />, label: '合作方渠道', group: '品牌同步高级设置' },
  { key: '/admin/sync-config-groups', icon: <CloudOutlined />, label: '同步配置组', group: '品牌同步高级设置' },
  { key: '/admin/sync-mapping-templates', icon: <FileTextOutlined />, label: '字段映射模板', group: '品牌同步高级设置' },
  { key: '/samples', icon: <SendOutlined />, label: '寄样&视频', group: '业务' },
  { key: '/video-import-records', icon: <VideoCameraOutlined />, label: '投流视频', group: '业务' },
  { key: '/video-sample-reconciliation', icon: <TeamOutlined />, label: '投流寄样对账', group: '业务' },
  { key: '/investment-history', icon: <VideoCameraOutlined />, label: '投流交付历史', group: '业务' },
  { key: '/script-orders', icon: <FileTextOutlined />, label: '稿费工单', group: '业务' },
  { key: '/fee-sync', icon: <FileTextOutlined />, label: '稿费双轮同步', group: '业务' },
  { key: '/fee-owner-config', icon: <TeamOutlined />, label: '稿费同步人员配置', group: '配置' },
  { key: '/analysis', icon: <RiseOutlined />, label: '产品分析', group: '分析' },
  { key: '/feishu-import', icon: <ImportOutlined />, label: '飞书导入', group: '工具' },
  { key: '/timeout-rules', icon: <FieldTimeOutlined />, label: '寄样超时规则', group: '配置' },
  { key: '/script-timeout-rules', icon: <ClockCircleOutlined />, label: '稿费超时规则', group: '配置' },
  { key: '/sample-policy-settings', icon: <SafetyCertificateOutlined />, label: '寄样规则', group: '配置' },
  { key: '/business-rules', icon: <SafetyCertificateOutlined />, label: '合作规则', group: '配置' },
  { key: '/oceanengine', icon: <LinkOutlined />, label: '千川授权', group: '配置' },
  { key: '/settings', icon: <SettingOutlined />, label: '系统设置', group: '配置' },
];

const bdMenu = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: '数据看板', group: '数据' },
  { key: '/today-workbench', icon: <BellOutlined />, label: '今日工作台', group: '业务' },
  { key: '/script-orders', icon: <FileTextOutlined />, label: '稿费工单', group: '业务' },
  { key: '/fee-sync', icon: <FileTextOutlined />, label: '稿费双轮同步', group: '业务' },
  { key: '/products', icon: <ShoppingOutlined />, label: '我的商品', group: '业务' },
  { key: '/creator-leads', icon: <TeamOutlined />, label: '达人建联', group: '业务' },
  { key: '/merchant-leads', icon: <ShopOutlined />, label: '招商公海', group: '业务资源' },
  { key: '/brand-sync-status', icon: <CloudOutlined />, label: '品牌同步状态', group: '业务' },
  { key: '/brand-workbench', icon: <AppstoreOutlined />, label: '品牌工作台', group: '品牌工作台' },
  { key: '/my-samples', icon: <InboxOutlined />, label: '我的寄样', group: '品牌工作台' },
  { key: '/samples', icon: <SendOutlined />, label: '寄样&视频', group: '业务' },
  { key: '/merchant-relations', icon: <LinkOutlined />, label: '商家绑定', group: '业务' },
  { key: '/analysis', icon: <RiseOutlined />, label: '产品分析', group: '分析' },
];

const creatorMenu = [
  { key: '/workbench', icon: <DesktopOutlined />, label: '今日工作台', group: '工作' },
  { key: '/today-workbench', icon: <BellOutlined />, label: '跟进工作台', group: '工作' },
  { key: '/dashboard', icon: <DashboardOutlined />, label: '数据看板', group: '工作' },
  { key: '/workload', icon: <FormOutlined />, label: '工作量记录', group: '工作' },
  { key: '/script-orders', icon: <FileTextOutlined />, label: '稿费工单', group: '业务' },
  { key: '/fee-sync', icon: <FileTextOutlined />, label: '稿费双轮同步', group: '业务' },
  { key: '/anchors', icon: <UserOutlined />, label: '我的达人', group: '业务' },
  { key: '/creator-leads', icon: <TeamOutlined />, label: '达人建联', group: '业务' },
  { key: '/public-pool', icon: <TeamOutlined />, label: '达人公海', group: '业务' },
  { key: '/sample-register', icon: <SendOutlined />, label: '寄样登记', group: '业务' },
  { key: '/brand-workbench', icon: <AppstoreOutlined />, label: '品牌工作台', group: '品牌工作台' },
  { key: '/my-samples', icon: <InboxOutlined />, label: '我的寄样', group: '品牌工作台' },
  { key: '/products', icon: <ShoppingOutlined />, label: '商品列表', group: '业务' },
  { key: '/samples', icon: <SendOutlined />, label: '寄样&视频', group: '业务' },
  { key: '/video-import-records', icon: <VideoCameraOutlined />, label: '投流视频', group: '业务' },
  { key: '/video-sample-reconciliation', icon: <TeamOutlined />, label: '投流寄样对账', group: '业务' },
  { key: '/investment-history', icon: <VideoCameraOutlined />, label: '投流交付历史', group: '业务' },
  { key: '/analysis', icon: <RiseOutlined />, label: '产品分析', group: '分析' },
];

const supervisorMenu = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: '数据看板', group: '数据' },
  { key: '/workload-dashboard', icon: <BarChartOutlined />, label: '工作量看板', group: '数据' },
  { key: '/today-workbench', icon: <BellOutlined />, label: '今日工作台', group: '业务' },
  { key: '/anchors', icon: <UserOutlined />, label: '达人管理', group: '业务' },
  { key: '/my-anchors', icon: <UserOutlined />, label: '我的达人', group: '业务' },
  { key: '/creator-leads', icon: <TeamOutlined />, label: '达人建联', group: '业务' },
  { key: '/public-pool', icon: <TeamOutlined />, label: '达人公海', group: '业务' },
  { key: '/products', icon: <ShoppingOutlined />, label: '商品列表', group: '业务' },
  { key: '/brand-sync-status', icon: <CloudOutlined />, label: '品牌同步状态', group: '业务' },
  { key: '/brand-workbench', icon: <AppstoreOutlined />, label: '品牌工作台', group: '品牌工作台' },
  { key: '/my-samples', icon: <InboxOutlined />, label: '我的寄样', group: '品牌工作台' },
  { key: '/samples', icon: <SendOutlined />, label: '寄样&视频', group: '业务' },
  { key: '/video-import-records', icon: <VideoCameraOutlined />, label: '投流视频', group: '业务' },
  { key: '/video-sample-reconciliation', icon: <TeamOutlined />, label: '投流寄样对账', group: '业务' },
  { key: '/investment-history', icon: <VideoCameraOutlined />, label: '投流交付历史', group: '业务' },
  { key: '/script-orders', icon: <FileTextOutlined />, label: '稿费工单', group: '业务' },
  { key: '/fee-sync', icon: <FileTextOutlined />, label: '稿费双轮同步', group: '业务' },
  { key: '/fee-owner-config', icon: <TeamOutlined />, label: '稿费同步人员配置', group: '配置' },
  { key: '/analysis', icon: <RiseOutlined />, label: '产品分析', group: '分析' },
];

const menuMap: Record<string, any[]> = {
  admin: adminMenu, bd: bdMenu, creator: creatorMenu, supervisor: supervisorMenu,
};

const roleLabelMap: Record<string, string> = {
  admin: '管理员',
  supervisor: '主管',
  bd: '招商运营',
  creator: '达人商务',
};

// ───────── Logo 组件 ─────────

function Logo({ collapsed }: { collapsed: boolean }) {
  return (
    <div style={{
      height: 64,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: collapsed ? '16px 8px' : '16px 20px',
      borderBottom: '1px solid #E6EDF5',
    }}>
      <div style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: 'linear-gradient(135deg, #2F80ED, #1C6DD0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <AppstoreOutlined style={{ fontSize: 20, color: '#fff' }} />
      </div>
      {!collapsed && (
        <div style={{ marginLeft: 12, overflow: 'hidden' }}>
          <div style={{
            fontSize: 16,
            fontWeight: 700,
            color: '#102A43',
            lineHeight: '22px',
          }}>
            团长后台
          </div>
          <div style={{
            fontSize: 11,
            color: '#6B7C8F',
            lineHeight: '16px',
          }}>
            让跟进更简单
          </div>
        </div>
      )}
    </div>
  );
}

// ───────── 菜单分组处理 ─────────

function getMenuItems(menu: any[]) {
  const groups: Record<string, any[]> = {};
  const groupOrder: string[] = [];

  menu.forEach(item => {
    const group = item.group || '其他';
    if (!groups[group]) {
      groups[group] = [];
      groupOrder.push(group);
    }
    groups[group].push({
      key: item.key,
      icon: item.icon,
      label: item.label,
    });
  });

  if (groupOrder.length <= 1) {
    return groups[groupOrder[0]] || [];
  }

  return groupOrder.map((group, index) => ({
    type: 'group' as const,
    label: (
      <span style={{
        fontSize: 11,
        color: '#98A2B3',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        padding: '0 4px',
      }}>
        {group}
      </span>
    ),
    children: groups[group],
    style: index > 0 ? { marginTop: 8 } : {},
  }));
}

// ───────── 主布局 ─────────

export default function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { currentUser: user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      message.error(getApiErrorMessage(error, '退出失败，请稍后重试'));
    }
  };

  if (!user) {
    return null;
  }

  const getUserMenus = () => {
    const roles = new Set(user.roles?.length ? user.roles : [user.role]);
    if (roles.has('admin')) return adminMenu;
    const baseMenus = menuMap[user.role] || creatorMenu;
    const crossDomain = roles.has('bd') && (roles.has('creator') || roles.has('supervisor'));
    return crossDomain
      ? baseMenus.filter((item) => !['/merchant-leads', '/public-pool', '/operation-logs'].includes(item.key))
      : baseMenus;
  };

  const menus = getUserMenus();
  const menuItems = getMenuItems(menus);
  const role = user.role || '';

  // 获取当前页面标题
  const currentPage = menus.find((m) => {
    const seg = m.key;
    return location.pathname === seg || location.pathname.startsWith(seg === '/dashboard' ? '/dashboard' : seg + '/');
  });
  const pageTitle = currentPage?.label || '';

  // 用户下拉菜单
  const userDropdownItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人信息',
      disabled: true,
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="app-shell">
      {/* 侧边栏 */}
      <Sider
        className="app-sidebar"
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="lg"
        width={220}
        collapsedWidth={64}
        style={{
          background: '#FFFFFF',
          boxShadow: '2px 0 8px rgba(0, 0, 0, 0.04)',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100,
          overflow: 'hidden',
        }}
        trigger={null}
      >
        <Logo collapsed={collapsed} />
        <div id="app-sidebar-navigation" className="app-sidebar-menu">
          <Menu
            mode="inline"
            selectedKeys={[currentPage?.key || location.pathname]}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
            style={{
              background: 'transparent',
              border: 'none',
            }}
          />
        </div>
        {/* 固定在菜单滚动区之外，折叠后仍保留清晰、可发现的恢复入口。 */}
        <div className="app-sidebar-footer">
          <Tooltip title={collapsed ? '展开侧边栏' : '收起侧边栏'} placement="right">
            <Button
              type="text"
              className="app-sidebar-toggle"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              aria-label={collapsed ? '展开侧边栏' : '收起侧边栏'}
              aria-expanded={!collapsed}
              aria-controls="app-sidebar-navigation"
              onClick={() => setCollapsed(current => !current)}
            >
              {!collapsed && <span>收起侧边栏</span>}
            </Button>
          </Tooltip>
        </div>
      </Sider>

      {/* 主内容区 */}
      <Layout className="app-main-layout" style={{
        marginLeft: collapsed ? 64 : 220,
        transition: 'margin-left 0.2s',
        minWidth: 0, /* 允许内容收缩 */
      }}>
        {/* 顶部导航 */}
        <Header className="app-header">
          {/* 左侧：页面标题 */}
          <div className="app-header-title">
            <span style={{
              fontSize: 16,
              fontWeight: 600,
              color: '#102A43',
            }}>
              {pageTitle}
            </span>
          </div>

          {/* 右侧：通知图标 + 用户信息 */}
          <div className="app-header-actions">
            {/* 搜索图标已移除：当前无实际功能，点击无反应 */}
            <div className="app-header-icon-btn">
              <Badge count={0} size="small">
                <Button
                  type="text"
                  icon={<BellOutlined />}
                  style={{ color: '#6B7C8F' }}
                  size="small"
                />
              </Badge>
            </div>
            <Dropdown menu={{ items: userDropdownItems }} placement="bottomRight">
              <div className="app-user-info" style={{ cursor: 'pointer' }}>
                <div className="app-user-avatar">
                  <Avatar
                    size={32}
                    style={{
                      background: '#2F80ED',
                      fontSize: 14,
                    }}
                  >
                    {(user?.name || '').slice(0, 1)}
                  </Avatar>
                </div>
                <span className="app-user-name">
                  {user?.name}
                </span>
              </div>
            </Dropdown>
          </div>
        </Header>

        {/* 页面内容 */}
        <Content className="app-main-content" style={{
          margin: 16,
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

// Badge 组件（避免引入整个 antd）
function Badge({ count, children, size }: { count: number; children: React.ReactNode; size?: string }) {
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {children}
      {count > 0 && (
        <span style={{
          position: 'absolute',
          top: -4,
          right: -4,
          background: '#E5484D',
          color: '#fff',
          fontSize: 10,
          minWidth: 16,
          height: 16,
          lineHeight: '16px',
          textAlign: 'center',
          borderRadius: 8,
          padding: '0 4px',
        }}>
          {count > 99 ? '99+' : count}
        </span>
      )}
    </div>
  );
}
